module.exports = __webpack_public_path__ + "img/electrot.dd7c713e.jpeg";